import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import { ExternalApisService } from 'src/app/services/external-apis.service';
import {ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { identifierModuleUrl } from '@angular/compiler';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {
  public theHtmlString ="";

  retItem: any;
  retItems: any;
  vidItems: any;
vid: any;
video_list: any;
  constructor(private externalApis: ExternalApisService, private genericService: GenericService, private sanitizer:DomSanitizer, private route: ActivatedRoute) { 

  }

  ngOnInit() {

    this.route.params.subscribe( params => {console.log(params);
      if(params.id != "357"){
        var str = "https://www.youtube.com/embed/" + params.id;
        this.vid = this.doTransform(str);
     //   this.GetPosts(params.catId);
      }
      else{
        this.vid = this.doTransform("https://www.youtube.com/embed/rBholomiGN0");
    //  this.GetPostById(params.id);
      }
                
          });


console.log(this.vid);
    this.LoadData();
  //  this.route.params.subscribe( params => {console.log(params);
      this.getVideos();

 //   });


  }
  doTransform(url:any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getVideos() {
    
    this.externalApis.getVideos().subscribe((data) => {
      this.vidItems = data;
      this.video_list = data.items.filter(a => a.snippet.title != "Private video");
      // console.log(this.retItem);
      //   this.theHtmlString = this.retItem.html_content;
    }), 
    err => {
         console.log(err);
      }
  }

  LoadData() {
    
    this.genericService.getItem(357).subscribe((data) => {
      this.retItem = data;
      console.log(this.retItem);

        this.theHtmlString = this.retItem.html_content;

    }
    )
      , err => {
        console.log(err);
      }
  }
}
